import { Text } from './Text'
import { Heading } from './Heading'

export const Typography = {
  Text,
  Heading
}
